// export const appConfig = {
//   applicationApi: { api: process.env.REACT_APP_API },
// };

import { URLKeyTypes } from "../types/urlKeyType";

export const endPoints = {
  loginUser: `/auth/token`,
  userManagement: {
    registerUser: `/users/register`,
    updateUser: `/users/`,
    getAllUser: `/users/getAll`,
    deleteUser: `/users/{email}`,
    emailBasedUser: `/users/{email}/select`,
    approve: `/users/{email}`,
    create: "/users/",
    select: "/users/{email}",
    defaultUser: `/users/role/update`,
    changePassword: `/users/`,
    userRoles: `/users/get_user_roles/`,
  },
  role: {
    create: `/roles/`,
    update: `/roles/`,
    getAll: `/roles/getAll`,
    delete: `/roles/{code}`,
    select: `/roles/{code}`,
  },
  permissions: {
    getAllPermissions: `/permissions/`,
    UIPermissions: `/users/get_user_ui_permissions/`,
  },
  studies: {
    create: `/studies/`,
    getAll: `/studies/getAll`,
    update: `/studies/`,
    delete: `/studies/{study_id}`,
    select: `/studies/{study_id}`,
  },
  sites: {
    create: `/sites`,
    getAll: `/sites/{study_id}`,
    update: `/sites/`,
    delete: `/sites/{study_id}/{site_id}`,
    select: `/sites/{study_id}/{site_id}`,
  },
  codelist: {
    getCodelist: `/codelist`,
    codelistLib: `/codelist/getCodeListLibrary`,
    codelistValues: `/codelist/{code_list_code}/getCodeListValues`,
    createCodelistValues: `/codelist/{code_list_code}`,
    updateCodelistValues: `/codelist/{code_list_code}`,
  },
  centralLab: {
    create: `/centralLab`,
    update: `/centralLab`,
    delete: `/centralLab/{study_id}/{central_lab_id}`,
    select: `/centralLab/{study_id}`,
  },
  vendors: {
    create: `/vendors`,
    getAll: `/vendors/{study_id}`,
    update: `/vendors/`,
    delete: `/vendors/{study_id}/{vendor_id}`,
    select: `/vendors/{study_id}/{vendor_id}`,
  },
  protocol: {
    upload: `/protocol/{study_id}`,
    download: `/protocol/download/{protocol_uuid}`,
    getAll: `/protocol/{study_id}`,
    delete: `/protocol/{protocol_uuid}`,
    update: `/protocol/{protocol_uuid}`,
  },
  forgotPassword: {
    getPasscode: `/users/{email}/get_passcode`,
    resetPassword: `/users/reset/password`,
  },
  audit: {
    getAudit: `/audit/getAudit/`,
    getAuditDetails: `/audit/`,
    moduleAudit: `/audit/{module}`,
  },
  connector: {
    create: `/connector/`,
    getAll: `/connector`,
    details: `/connector/details/{connector_id}`,
    externalData: `/connector/{connector_id}`,
  },
  entity: {
    getAll: `/dynamic`,
    selectEntity: `/dynamic/{table_name}`,
    create: `/dynamic`,
    update: `/dynamic`,
    createAlembicRevision: `/dynamic/createRevision`,
    upgradeAlembicRevision: `/dynamic/upgradeRevision`,
  },
  component: {
    getAllList: `/component/list`,
    getAllDetails: `/component/detail`,
    getAllPageLayout: `/component/layout`,
  },
  generic: {
    getAll: `generic/inventory`,
    select: `generic/select`,
  },
  transformation: {
    path: `/transformation/`,
    getTransformation: `/transformation/{entity_name}`,
  },
};

export const baseURL = process.env.REACT_APP_LOCAL_API
  ? `${process.env.REACT_APP_LOCAL_API}/api`
  : "/api";

export const urlKeys: URLKeyTypes = {
  user_id: `user_id`,
  email: `email`,
  code: `code`,
  study_id: `study_id`,
  site_id: `site_id`,
  central_lab_id: `central_lab_id`,
  vendor_id: `vendor_id`,
  protocol_name: `protocol_name`,
  protocol_uuid: `protocol_uuid`,
  module: `module`,
  code_list_code: `code_list_code`,
  connector_id: `connector_id`,
  table_name: `table_name`,
  entity_name: `entity_name`,
};
